import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { PrimaryButton, Stack } from '@fluentui/react';
export const SignInButton: React.FC = () => {
    const { instance } = useMsal();

    const handleLogin = (loginType: string) => {
        if (loginType === 'popup') {
            instance.loginPopup(loginRequest);
        } else if (loginType === 'redirect') {
            instance.loginRedirect(loginRequest);
        }
    };

    return (
        <Stack>
            <PrimaryButton text="Sign in" onClick={() => handleLogin('redirect')} />
        </Stack>
    );
};